import { graphql } from 'react-relay';
import type { Znglists_Pagination_Query$variables } from './__generated__/Znglists_Pagination_Query.graphql';

export * from './__generated__/Znglists_Pagination_Fragment.graphql';

export type Znglists_Pagination_Fragment$args = Znglists_Pagination_Query$variables;

export const ZnglistsPaginationFragment = graphql`
  fragment Znglists_Pagination_Fragment on RootQuery
  @argumentDefinitions(
    first: { type: "Int" }
    after: { type: "String" }
    where: { type: "RootQueryToZnglistConnectionWhereArgs" }
  )
  @refetchable(queryName: "Znglists_Pagination_Query") {
    znglists(first: $first, after: $after, where: $where)
      @connection(key: "Znglists_Pagination_Fragment_Connection_znglists") {
      __id
      edges {
        node {
          id
          title
          status
          link
          slug
          date
          modified
          trashDate
          trashTimeUntil
          author {
            ...Frags_With_Author_Fragment @relay(mask: false)
          }
          statusSettings {
            ...Frags_Status_Settings_Fragment @relay(mask: false)
          }
          znglist {
            order
            userType
            templateType
            znglyContents {
              ... on ZnglyVideo {
                id
                znglyContent {
                  featuredImageFile {
                    ...Media_Url_Fragment @relay(mask: false)
                  }
                  featuredImageLink
                }
              }
            }
          }
        }
      }
    }
  }
`;

export * from './__generated__/Znglists_Query.graphql';
export const ZnglistsQuery = graphql`
  query Znglists_Query {
    ...Znglists_Pagination_Fragment
    @arguments(
        first: 24
        after: null
        where: { stati: [PUBLISH, HIDDEN, HIDDEN_B_S, DRAFT, PENDING], search: null, orderby: null, authorIn: null, dateQuery: null }
      )
  }
`;

export type {
  Znglist_ZnglyContents_Fragment$data,
  Znglist_ZnglyContents_Fragment$key,
} from './__generated__/Znglist_ZnglyContents_Fragment.graphql';
export const ZnglistContentsFragment = graphql`
  fragment Znglist_ZnglyContents_Fragment on Znglist_Znglist {
    znglyContents {
      ... on ZnglyVideo {
        id
        databaseId
        ...ZnglyVideo_Single_Fragment @relay(mask: false)
      }
    }
  }
`;

export type { Znglist_Fragment$data, Znglist_Fragment$key } from './__generated__/Znglist_Fragment.graphql';
export const ZnglistFragment = graphql`
  fragment Znglist_Fragment on Znglist {
    id
    author {
      ...Frags_With_Author_Fragment @relay(mask: false)
    }
    title
    link
    status
    slug
    statusSettings {
      ...Frags_Status_Settings_Fragment @relay(mask: false)
    }
    znglist {
      order
      userType
      templateType
      ...Znglist_ZnglyContents_Fragment @relay(mask: false)
      form {
        node {
          ...Frags_Frontend_Form_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export * from './__generated__/Znglist_By_Query.graphql';
export const ZnglistByQuery = graphql`
  query Znglist_By_Query($id: ID) {
    znglistBy(id: $id) {
      id
      author {
        ...Frags_With_Author_Fragment @relay(mask: false)
      }
      title
      link
      status
      slug
      znglist {
        order
        userType
        templateType
        ...Znglist_ZnglyContents_Fragment
        znglyContents {
          ... on ZnglyVideo {
            databaseId
          }
        }
        form {
          node {
            id
            title
            content
          }
        }
      }
    }
  }
`;

export type { Znglist_Query, Znglist_Query$data, Znglist_Query$variables } from './__generated__/Znglist_Query.graphql';
export const ZnglistQuery = graphql`
  query Znglist_Query($id: ID!) {
    znglist(id: $id) {
      ...Znglist_Fragment @relay(mask: false)
    }
  }
`;

export type {
  Znglist_Single_Short_Query,
  Znglist_Single_Short_Query$data,
  Znglist_Single_Short_Query$variables,
  ZnglistIdType,
} from './__generated__/Znglist_Single_Short_Query.graphql';
export const ZnglistSingleShortQuery = graphql`
  query Znglist_Single_Short_Query($id: ID!, $idType: ZnglistIdType!) {
    znglist(id: $id, idType: $idType) {
      id,
      title
    }
  }
  `;

export type {
  Znglist_List_Query,
  Znglist_List_Query$data,
  Znglist_List_Query$variables,
} from './__generated__/Znglist_List_Query.graphql';
export const ZnglistListQuery = graphql`
  query Znglist_List_Query($first: Int, $after: String, $where: RootQueryToZnglistConnectionWhereArgs) {
    znglists(first: $first, after: $after, where: $where) {
      nodes {
        title
        id
      }
    }
  }
`;

export type {
  Znglist_Frontend_Single_Query,
  Znglist_Frontend_Single_Query$data,
  Znglist_Frontend_Single_Query$variables,
} from './__generated__/Znglist_Frontend_Single_Query.graphql';
export const ZnglistFrontendSingleQuery = graphql`
  query Znglist_Frontend_Single_Query($id: ID!, $idType: ZnglistIdType!, $userId: ID = "", $userIdType: UserNodeIdTypeEnum = ID, $isPersonalTemplate: Boolean = false) {
    znglist(id: $id, idType: $idType) {
      id
      author {
        node {
          ...Frags_Frontend_User_Meta_Fragment @relay(mask: false)
        }
      }
      title
      link
      status
      slug
      znglist {
        templateType
        znglyContents {
          ... on ZnglyVideo {
            id
            ...ZnglyVideo_Single_Fragment @relay(mask: false)
          }
        }
        form {
          node {
            ...Frags_Frontend_Form_Fragment @relay(mask: false)
          }
        }
      }
    }
    user(id: $userId, idType: $userIdType) {
      ...Frags_Frontend_User_Meta_Fragment @relay(mask: false) @include(if: $isPersonalTemplate)
    }
  }
`;
